import PropTypes from "prop-types"
import { Box } from "@mui/material"
import { percentageFormatter } from "helpers/formatters/numbers"
import { darken } from "helpers/colors"
import Ellipsable from "components/ellipsable"
import { ContentWrapper, ChartBar, ValueWrapper } from "../styled"

export default function ItemCell({ item, width, color, style, loading, chartBarFallbackWidth, compactValuePadding }) {
  const { label, value, chartWidth } = item

  return <Box className="cell" style={style}>
    <ContentWrapper className="content-wrapper">
      {!loading && (
        <ChartBar
          className="chart-bar"
          sx={{ background: darken(color, 0.7) }}
          // Keep the dynamic width as an inline style (not sx) so it renders as a readable
          // style="width: …" attribute — a per-value sx would emit an emotion class instead,
          // which both churns class names per value and hides the width from E2E extraction.
          style={{ width: chartWidth ?? chartBarFallbackWidth }}
        />
      )}
      <ValueWrapper className="value-wrapper" sx={compactValuePadding ? { paddingRight: "0.25rem" } : undefined}>
        <Ellipsable width={width}>{label}</Ellipsable>
        <Box className="value">{percentageFormatter(value / 100)}</Box>
      </ValueWrapper>
    </ContentWrapper>
  </Box>
}

ItemCell.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
    chartWidth: PropTypes.string,
  }).isRequired,
  width: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  style: PropTypes.object,
  loading: PropTypes.bool,
  chartBarFallbackWidth: PropTypes.string,
  compactValuePadding: PropTypes.bool,
}
